import React from 'react';
import { Navbar, Nav, Container, Button } from 'react-bootstrap';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { BoxArrowRight } from 'react-bootstrap-icons';
import DarkModeToggle from './DarkModeToggle';
import { useWeekNav } from '../contexts/WeekNavContext';
import { useWindowWidth } from '../hooks/useWindowWidth';
import { getWeekDates, formatDate } from '../utils/dateUtils';

const navBtnStyle = {
  width: 22, height: 22, borderRadius: 'var(--r-xs)',
  border: '1px solid var(--line)', background: 'transparent',
  color: 'var(--ink-3)', cursor: 'pointer', fontSize: 14,
  display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
};

function AppNavbar({ designVariant, setDesignVariant }) {
  const user      = JSON.parse(localStorage.getItem('user') || 'null');
  const isAdminUser = user?.role === 'admin' || user?.isAdmin;
  const homeLink  = user?.role === 'admin' ? '/admin' : user?.role === 'teacher' ? '/teacher' : '/';
  const navigate  = useNavigate();
  const location  = useLocation();
  const width     = useWindowWidth();
  const isMobile  = width < 768;
  const { selectedWeek, setSelectedWeek } = useWeekNav() || {};
  const showWeekNav = selectedWeek && (user?.role === 'teacher' || (!user && location.pathname === '/'));
  const weekDates = showWeekNav ? getWeekDates(selectedWeek) : null;

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    navigate('/');
  };

  function setVariant(v) {
    localStorage.setItem('designVariant', v);
    setDesignVariant(v);
    window.dispatchEvent(new Event('designVariantChange'));
  }

  const weekNavContent = showWeekNav && (
    <div className="mono" style={{
      fontSize: 11, color: 'var(--ink-3)', letterSpacing: '0.06em',
      display: 'flex', alignItems: 'center', gap: 8, pointerEvents: 'auto',
    }}>
      <button style={navBtnStyle} onClick={() => setSelectedWeek(w => Math.max(1, w - 1))}>‹</button>
      KW {selectedWeek} · {formatDate(weekDates[0]).slice(0, 5)} — {formatDate(weekDates[4]).slice(0, 5)}
      <button style={navBtnStyle} onClick={() => setSelectedWeek(w => Math.min(52, w + 1))}>›</button>
    </div>
  );

  return (
    <Navbar expand="md" style={{ position: 'sticky', top: 0, zIndex: 100, flexWrap: 'wrap' }}>
      <Container fluid style={{ paddingLeft: '1rem', paddingRight: '1rem' }}>
        {showWeekNav && !isMobile && (
          <div style={{
            position: 'absolute', left: 0, right: 0,
            display: 'flex', justifyContent: 'center',
            pointerEvents: 'none', zIndex: 0,
          }}>
            {weekNavContent}
          </div>
        )}
        <Navbar.Brand as={Link} to={homeLink}>
          Wochenplaner
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto align-items-center gap-2">

            {(user?.role === 'teacher' || user?.role === 'admin') && (
              <Nav.Item className="tab-row" style={{ margin: 0 }}>
                <button className={designVariant === 'A' ? 'active' : ''} onClick={() => setVariant('A')}>A</button>
                <button className={designVariant === 'B' ? 'active' : ''} onClick={() => setVariant('B')}>B</button>
              </Nav.Item>
            )}

            <Nav.Item className="d-flex align-items-center">
              <DarkModeToggle />
            </Nav.Item>

            {user && (
              <>
                {isAdminUser && location.pathname !== '/admin' && (
                  <Nav.Item>
                    <Button as={Link} to="/admin" variant="outline-secondary" size="sm">
                      Verwaltung
                    </Button>
                  </Nav.Item>
                )}
                <Nav.Item className="d-flex align-items-center">
                  <span className="text-muted small">{user.name || user.username}</span>
                </Nav.Item>
                <Nav.Item>
                  <Button variant="outline-secondary" size="sm" onClick={handleLogout} className="d-flex align-items-center gap-1">
                    <BoxArrowRight size={16} />
                    Abmelden
                  </Button>
                </Nav.Item>
              </>
            )}
          </Nav>
        </Navbar.Collapse>
      </Container>
      {showWeekNav && isMobile && (
        <div style={{ width: '100%', display: 'flex', justifyContent: 'center', padding: '4px 0 10px' }}>
          {weekNavContent}
        </div>
      )}
    </Navbar>
  );
}

export default AppNavbar;
